/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ProgressCircle from '../../../components/ProgressCircle'
import ImageContainer from './ImageContainer';
import firebase from 'firebase';

export default function Edit() {
  const { pid, collection } = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});

  useEffect(() => {
    const loadData = async () => {
      setLoading(true)
      const result = await firebase.functions().httpsCallable("getAdminProduct")({
        collection: collection,
        pid: pid,
      });
      console.log(result.data)
      if (result.data.result) {
        setData(result.data.data)
      }
      setLoading(false)
    }
    loadData();
  }, [])

  const finalPrice = () => {
    return (parseFloat(data.price) * ((100 - parseFloat(data.discount)) / 100)) || 0;
  }

  const submit = async () => {
    setLoading(true)
    const result = await firebase.functions().httpsCallable("updateProduct")({
      collection: collection,
      pid: pid,
      payload: data,
    });
    if (!result.data.result) {
      alert(result.data.message);
    }
    setLoading(false)
  }

  const cancel = () => {
    window.history.back();
  }

  const deleteTheProduct = async () => {
    const result = await firebase.functions().httpsCallable('adminDeleteProduct')({
      collection: collection,
      pid: pid,
    })
    if (result.data.result) {
      window.open('/', '_self')
    }else{
      console.log(result.data)
    }
  }

  const deleteMe = () => {
    // eslint-disable-next-line no-restricted-globals
    const conf = confirm("Are you sure?")
    if (conf) {
      // delete this
      deleteTheProduct()
    }
  }

  if (loading) {
    return <div style={{ width: 'max-content', margin: 'auto', marginTop: '42vh' }}>
      <ProgressCircle />
    </div>;
  }

  return (
    <div className="container-sm p-2">
      <div className="card p-3">
        <div>
          <a href={`/p/${data?.uid}`}><h2>Profile</h2></a>
          <div className="form-group mb-3">
            <label>Title</label>
            <input className="form-control" placeholder="Title" value={data.category} onChange={(text) => {
              data.category = text.target.value;
              setData({ ...data });
            }} />
          </div>

          <div className="form-group mb-3">
            <label>Brand</label>
            <input className="form-control" placeholder="Brand" value={data.brand || ""} onChange={(text) => {
              data.brand = text.target.value;
              setData({ ...data });
            }} />
          </div>

          <div className="form-group mb-3">
            <label>Category</label>
            <input className="form-control" placeholder="Category" value={data.subCategory || ""} onChange={(text) => {
              data.subCategory = text.target.value;
              setData({ ...data });
            }} />
          </div>

          <div className="form-group mb-3">
            <label>Size</label>
            <input className="form-control" placeholder="S, M ... 2XL, 3XL" value={data.size || ""} onChange={(text) => {
              data.size = text.target.value;
              setData({ ...data });
            }} />
          </div>

          <div className="form-group mb-3">
            <label>Color</label>
            <input className="form-control" placeholder="ColorName" value={data.colorName || ""} onChange={(text) => {
              data.colorName = text.target.value;
              setData({ ...data });
            }} />
          </div>

          <div className="form-group mb-3">
            <label>Price</label>
            <div className="row gap-3 p-3 pt-0 pb-0">
              <input type={"number"} className="form-control col" placeholder="საწყისი ფასი" min="0" value={data.price || ""} onChange={(text) => {
                data.price = parseFloat(text.target.value);
                setData({ ...data });
              }} />
              <input type={"number"} className="form-control col" placeholder="ფასდაკლება" min="0" max="100" value={data.discount || ""} onChange={(text) => {
                data.discount = parseFloat(text.target.value || 0);
                setData({ ...data });
              }} />
              <input type={"number"} className="form-control col" placeholder={`საბოლოო ფასი: ${finalPrice()} GEL`} disabled />
            </div>
          </div>

          <div className="form-group mb-3">
            <label>Price</label>
            <div className="gap-3 p-3 pt-0 pb-0">
              {data?.photos?.map((img, i) => {
                return <ImageContainer key={img} imageUrl={img} onRemove={() => {
                  const photos = data.photos.filter(x => x !== img)
                  data.photos = [...photos];
                  setData({ ...data })
                }} />
              })}
            </div>
          </div>

          {/* <div className="form-group mb-3">
            <label>Size</label>
            <select className="form-control">
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
            </select>
          </div> */}

          <div className="form-group">
            <label>Description</label>
            <textarea className="form-control" rows="3" value={data.description || ""} onChange={(text) => {
              data.description = text.target.value;
              setData({ ...data });
            }}></textarea>
          </div>
          <div className="row p-3 gap-3 pb-0">
            <button onClick={submit} className="btn btn-primary col">Save</button>
            <button onClick={cancel} className="btn btn-danger col">Back</button>
            <button onClick={deleteMe} className="btn btn-danger col">DELETE</button>
          </div>
        </div>
      </div>
    </div>
  )
}
